import React from 'react'
import { IYesNoButtons } from '../../interfaces/FormFields'
import RadioButton from './RadioButton'
import { ALERT_MESSAGES } from '../../enums/common'

const YesNoButtons = ({
  id,
  name,
  label,
  value,
  register,
  groupLabelClassName = '',
  labelClassName = '',
  disabled,
  error,
  required,
  yesValue = '0',
  noValue = '1',
  onChange,
}: IYesNoButtons) => {
  return (
    <>
      {label && (
        <p
          className={`inputRadioGroupLabel ${groupLabelClassName} ${
            required ? 'inputRadioGroupLabelRequired' : ''
          }`}
        >
          {label}
        </p>
      )}
      <div className="dFlex alignItemsCenter">
        <RadioButton
          id={id}
          name={name}
          register={register}
          label="Oui"
          value={yesValue}
          labelClassName={`${labelClassName} mr5`}
          error={error}
          disabled={disabled}
          checked={value === yesValue}
          onChange={onChange}
        />
        <RadioButton
          id={id}
          name={name}
          register={register}
          label="Non"
          value={noValue}
          labelClassName={labelClassName}
          error={error}
          disabled={disabled}
          checked={value === noValue}
          onChange={onChange}
        />
      </div>
      {error && (
        <p className={`${ALERT_MESSAGES.mandatory.type}Error`}>
          {ALERT_MESSAGES.mandatory.message}
        </p>
      )}
    </>
  )
}

export default YesNoButtons
